export const GATEWAY_LIST_FILTER_ALL = 'all'

export const GATEWAY_LIST_STATUS_OPTIONS = [
  { id: GATEWAY_LIST_FILTER_ALL, label: 'All statuses' },
  { id: 'online', label: 'Online' },
  { id: 'offline', label: 'Offline' },
  { id: 'warning', label: 'Warning' },
  { id: 'error', label: 'Error' },
] as const

export const GATEWAY_LIST_RUNTIME_OPTIONS = [
  { id: GATEWAY_LIST_FILTER_ALL, label: 'All runtimes' },
  { id: 'node', label: 'Node.js' },
  { id: 'python', label: 'Python' },
  { id: 'java', label: 'Java' },
  { id: 'dotnet', label: '.NET' },
] as const

/** Default row for hosted-module filter (`feed` in forms). Other options are built from gateway data. */
export const GATEWAY_LIST_MODULE_OPTIONS = [{ id: GATEWAY_LIST_FILTER_ALL, label: 'All modules' }] as const

/** Default row for project-key filter. Other options are built from project keys and gateway data. */
export const GATEWAY_LIST_PROJECT_KEY_OPTIONS = [{ id: GATEWAY_LIST_FILTER_ALL, label: 'All project keys' }] as const

export type GatewayListSelectOption = { id: string; label: string }
